import { featureFlags, type FeatureName } from "~/helpers/feature-helpers";

export const useIsFeatureSupported = () => {
  const app = useNuxtApp();

  return (feature: FeatureName) => {
    const flags = featureFlags(app).filter((f) => f.name === feature);

    if (flags.length == 0) {
      return true;
    } else {
      return flags.some((f) => f.active);
    }
  };
};
